<div mat-dialog-title>{{ $pueblo().name }}</div>

<div mat-dialog-content>
  <div class="my-stats">
    <div class="title-medium">My stats</div>
    <div>TBD</div>
  </div>
  <div class="pueblo-stats">
    <div class="title-medium">Pueblo stats</div>
    <div class="stats-row">
      <div>
        {{ $pueblo().members.length }}
        {{ $pueblo().members.length === 1 ? "user" : "users" }}
      </div>
      <div>
        {{ $pueblo().hangs.length }}
        {{ $pueblo().hangs.length === 1 ? "hang" : "hangs" }}
      </div>
    </div>
  </div>
</div>

<div mat-dialog-actions>
  <button mat-flat-button>
    <mat-icon>explore</mat-icon>
    Discover
  </button>
</div>
